// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Web-specific styles */

/* Mobile adjustments for floating bonus */
@media (max-width: 768px) {
  .floating-bonus-indicator {
    font-size: 2.2rem;
    padding: 10px 20px;
  }
  
  .floating-bonus-indicator::before,
  .floating-bonus-indicator::after {
    font-size: 1.3rem;
  }
  
  @keyframes float-down-fade-right {
    0% {
      opacity: 0;
      transform: translateY(-50%) scale(0.8);
    }
    15% {
      opacity: 1;
      transform: translate(-50%, -50%) scale(1);
    }
    85% {
      opacity: 1;
      transform: translate(-50%, 250px) scale(1);
    }
    100% {
      opacity: 0;
      transform: translate(-50%, 350px) scale(0.8);
    }
  }
}

@media (max-width: 768px) {
  .modal {
    padding: 16px;
  }
  
  .modal-content {
    max-width: 95%;
    max-height: 90vh;
    margin: 5vh auto;
  }
  
  .modal-header {
    padding: 1rem;
  }
  
  .modal-header h2 {
    font-size: 1.3rem;
  }
  
  .modal-body {
    padding: 1rem;
  }
  
  .modal-footer {
    padding: 1rem;
  }
  
  .high-scores-header,
  .high-score-entry {
    font-size: 0.8rem;
    padding: 0.5rem 0.3rem;
  }
  
  .header-rank, .entry-position {
    width: 15%;
  }
  
  .header-score, .entry-points {
    width: 20%;
  }
  
  .header-accuracy, .entry-accuracy {
    width: 20%;
  }
  
  .header-date, .entry-date {
    width: 25%;
  }
  
  .header-name, .entry-name {
    width: 20%;
  }
  
  .game-over-container .game-stats {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
    padding: 0 1rem;
    width: auto;
  }
  
  .game-info .game-stats {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
    width: 100%;
    justify-items: center;
  }
  
  .game-info .timer-stat {
    grid-column: 1 / -1;
  }
  
  .game-over-container .stat,
  .game-info .stat {
    width: 100%;
    min-height: 80px;
    padding-top: 1rem;
    padding-bottom: 1rem;
    justify-content: center;
  }
  
  .game-over-container .stat-value,
  .game-info .stat-value {
    font-size: 2rem;
    font-weight: 700;
  }
}

@media (max-width: 480px) {
  .modal {
    padding: 8px;
  }
  
  .modal-content {
    max-width: 98%;
    max-height: 95vh;
    margin: 2.5vh auto;
  }
  
  .modal-header {
    padding: 0.8rem;
  }
  
  .modal-body {
    padding: 0.8rem;
  }
  
  .modal-footer {
    padding: 0.8rem;
  }
  
  .high-scores-header,
  .high-score-entry {
    font-size: 0.75rem;
    padding: 0.4rem 0.2rem;
  }
  
  .difficulty-group-header {
    font-size: 0.9rem;
    padding: 0.6rem 0.4rem;
  }
}

@media (max-width: 768px) {
  .info-modal-overlay {
    padding: 16px;
  }
  
  .info-modal-content {
    max-width: 95%;
    max-height: 90vh;
  }
  
  .info-modal-header {
    padding: 1rem;
  }
  
  .info-modal-header h3 {
    font-size: 1.3rem;
  }
  
  .info-modal-body {
    padding: 1rem;
  }
  
  .info-modal-footer {
    padding: 1rem;
  }
  
  .info-button {
    width: 24px;
    height: 24px;
    font-size: 16px;
    line-height: 24px;
  }
}

@media (max-width: 768px) {
  .privacy-policy-overlay {
    padding: 16px;
  }
  
  .privacy-policy-content {
    max-width: 95%;
    max-height: 90vh;
  }
  
  .privacy-policy-header {
    padding: 1rem;
  }
  
  .privacy-policy-header h2 {
    font-size: 1.3rem;
  }
  
  .privacy-policy-body {
    padding: 1rem;
  }
  
  .privacy-policy-footer {
    padding: 1rem;
  }
}

@media (max-width: 768px) {
  .game-stats {
    display: grid !important;
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 1rem !important;
    padding: 0 1rem !important;
    width: auto !important;
    max-width: 400px !important;
    margin: 0 auto !important;
  }
  
  .stat {
    flex: 1 !important;
    min-width: unset !important;
    padding: 1rem 0.5rem !important;
    margin-bottom: 0 !important;
    box-sizing: border-box !important;
    min-height: 80px !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
    align-items: center !important;
    text-align: center !important;
  }
  
  .stat-value {
    font-size: 2rem !important;
    font-weight: 700 !important;
    margin-bottom: 0.3rem !important;
  }
  
  .stat-label {
    font-size: 0.75rem !important;
  }
}

@media (max-width: 768px) {
  .tab-button {
    padding: 8px 12px;
    font-size: 0.85rem;
    min-width: 60px;
  }
} `, "",{"version":3,"sources":["webpack://./src/styles/web.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAExB,0CAA0C;AAC1C;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE;MACE,UAAU;MACV,sCAAsC;IACxC;IACA;MACE,UAAU;MACV,yCAAyC;IAC3C;IACA;MACE,UAAU;MACV,0CAA0C;IAC5C;IACA;MACE,UAAU;MACV,4CAA4C;IAC9C;EACF;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,eAAe;IACf,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,uBAAuB;EACzB;;EAEA;;IAEE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,gDAAgD;IAChD,oBAAoB;IACpB,0BAA0B;IAC1B,sBAAsB;IACtB,2BAA2B;IAC3B,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,2BAA2B;IAC3B,+BAA+B;IAC/B,2BAA2B;IAC3B,iCAAiC;IACjC,2BAA2B;IAC3B,wBAAwB;IACxB,iCAAiC;IACjC,kCAAkC;IAClC,8BAA8B;IAC9B,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,gCAAgC;EAClC;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;AACF","sourcesContent":["/* Web-specific styles */\n\n/* Mobile adjustments for floating bonus */\n@media (max-width: 768px) {\n  .floating-bonus-indicator {\n    font-size: 2.2rem;\n    padding: 10px 20px;\n  }\n  \n  .floating-bonus-indicator::before,\n  .floating-bonus-indicator::after {\n    font-size: 1.3rem;\n  }\n  \n  @keyframes float-down-fade-right {\n    0% {\n      opacity: 0;\n      transform: translateY(-50%) scale(0.8);\n    }\n    15% {\n      opacity: 1;\n      transform: translate(-50%, -50%) scale(1);\n    }\n    85% {\n      opacity: 1;\n      transform: translate(-50%, 250px) scale(1);\n    }\n    100% {\n      opacity: 0;\n      transform: translate(-50%, 350px) scale(0.8);\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .modal {\n    padding: 16px;\n  }\n  \n  .modal-content {\n    max-width: 95%;\n    max-height: 90vh;\n    margin: 5vh auto;\n  }\n  \n  .modal-header {\n    padding: 1rem;\n  }\n  \n  .modal-header h2 {\n    font-size: 1.3rem;\n  }\n  \n  .modal-body {\n    padding: 1rem;\n  }\n  \n  .modal-footer {\n    padding: 1rem;\n  }\n  \n  .high-scores-header,\n  .high-score-entry {\n    font-size: 0.8rem;\n    padding: 0.5rem 0.3rem;\n  }\n  \n  .header-rank, .entry-position {\n    width: 15%;\n  }\n  \n  .header-score, .entry-points {\n    width: 20%;\n  }\n  \n  .header-accuracy, .entry-accuracy {\n    width: 20%;\n  }\n  \n  .header-date, .entry-date {\n    width: 25%;\n  }\n  \n  .header-name, .entry-name {\n    width: 20%;\n  }\n  \n  .game-over-container .game-stats {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 1rem;\n    padding: 0 1rem;\n    width: auto;\n  }\n  \n  .game-info .game-stats {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 1rem;\n    width: 100%;\n    justify-items: center;\n  }\n  \n  .game-info .timer-stat {\n    grid-column: 1 / -1;\n  }\n  \n  .game-over-container .stat,\n  .game-info .stat {\n    width: 100%;\n    min-height: 80px;\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n    justify-content: center;\n  }\n  \n  .game-over-container .stat-value,\n  .game-info .stat-value {\n    font-size: 2rem;\n    font-weight: 700;\n  }\n}\n\n@media (max-width: 480px) {\n  .modal {\n    padding: 8px;\n  }\n  \n  .modal-content {\n    max-width: 98%;\n    max-height: 95vh;\n    margin: 2.5vh auto;\n  }\n  \n  .modal-header {\n    padding: 0.8rem;\n  }\n  \n  .modal-body {\n    padding: 0.8rem;\n  }\n  \n  .modal-footer {\n    padding: 0.8rem;\n  }\n  \n  .high-scores-header,\n  .high-score-entry {\n    font-size: 0.75rem;\n    padding: 0.4rem 0.2rem;\n  }\n  \n  .difficulty-group-header {\n    font-size: 0.9rem;\n    padding: 0.6rem 0.4rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .info-modal-overlay {\n    padding: 16px;\n  }\n  \n  .info-modal-content {\n    max-width: 95%;\n    max-height: 90vh;\n  }\n  \n  .info-modal-header {\n    padding: 1rem;\n  }\n  \n  .info-modal-header h3 {\n    font-size: 1.3rem;\n  }\n  \n  .info-modal-body {\n    padding: 1rem;\n  }\n  \n  .info-modal-footer {\n    padding: 1rem;\n  }\n  \n  .info-button {\n    width: 24px;\n    height: 24px;\n    font-size: 16px;\n    line-height: 24px;\n  }\n}\n\n@media (max-width: 768px) {\n  .privacy-policy-overlay {\n    padding: 16px;\n  }\n  \n  .privacy-policy-content {\n    max-width: 95%;\n    max-height: 90vh;\n  }\n  \n  .privacy-policy-header {\n    padding: 1rem;\n  }\n  \n  .privacy-policy-header h2 {\n    font-size: 1.3rem;\n  }\n  \n  .privacy-policy-body {\n    padding: 1rem;\n  }\n  \n  .privacy-policy-footer {\n    padding: 1rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .game-stats {\n    display: grid !important;\n    grid-template-columns: repeat(2, 1fr) !important;\n    gap: 1rem !important;\n    padding: 0 1rem !important;\n    width: auto !important;\n    max-width: 400px !important;\n    margin: 0 auto !important;\n  }\n  \n  .stat {\n    flex: 1 !important;\n    min-width: unset !important;\n    padding: 1rem 0.5rem !important;\n    margin-bottom: 0 !important;\n    box-sizing: border-box !important;\n    min-height: 80px !important;\n    display: flex !important;\n    flex-direction: column !important;\n    justify-content: center !important;\n    align-items: center !important;\n    text-align: center !important;\n  }\n  \n  .stat-value {\n    font-size: 2rem !important;\n    font-weight: 700 !important;\n    margin-bottom: 0.3rem !important;\n  }\n  \n  .stat-label {\n    font-size: 0.75rem !important;\n  }\n}\n\n@media (max-width: 768px) {\n  .tab-button {\n    padding: 8px 12px;\n    font-size: 0.85rem;\n    min-width: 60px;\n  }\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
